import { render, staticRenderFns } from "./aktarimDetay.vue?vue&type=template&id=1123b280&scoped=true&"
import script from "./aktarimDetay.vue?vue&type=script&lang=js&"
export * from "./aktarimDetay.vue?vue&type=script&lang=js&"
import style0 from "./aktarimDetay.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./aktarimDetay.vue?vue&type=style&index=1&lang=css&"
import style2 from "./aktarimDetay.vue?vue&type=style&index=2&id=1123b280&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1123b280",
  null
  
)

export default component.exports